import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartyPopper = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2431 1.36917C9.8947 0.940653 9.26487 0.875723 8.83636 1.22414C8.40784 1.57256 8.34291 2.20239 8.69133 2.6309C9.73145 3.91013 10.0678 5.63406 9.55125 7.1838C9.3766 7.70775 9.65976 8.27407 10.1837 8.44872C10.7077 8.62336 11.274 8.3402 11.4486 7.81626C12.1892 5.59451 11.6992 3.16001 10.2431 1.36917Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9999 3.00003C13.4476 3.00003 12.9999 3.44775 12.9999 4.00003C12.9999 4.55232 13.4476 5.00003 13.9999 5.00003H14.0099C14.5622 5.00003 15.0099 4.55232 15.0099 4.00003C15.0099 3.44775 14.5622 3.00003 14.0099 3.00003H13.9999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.2881 5.30703C22.8171 5.14828 23.1172 4.59077 22.9585 4.06179C22.7997 3.53281 22.2422 3.23268 21.7133 3.39142C18.1791 4.45201 15.0021 6.33042 12.6999 9.4C12.3685 9.84183 12.4581 10.4686 12.8999 10.8C13.3417 11.1314 13.9685 11.0418 14.2999 10.6C16.2897 7.94698 19.064 6.27458 22.2881 5.30703Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99991 4.00003C5.44763 4.00003 4.99991 4.44775 4.99991 5.00003C4.99991 5.55232 5.44763 6.00003 5.99991 6.00003H6.00991C6.5622 6.00003 7.00991 5.55232 7.00991 5.00003C7.00991 4.44775 6.5622 4.00003 6.00991 4.00003H5.99991Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6284 11.3716C11.402 10.1452 10.0977 9.17016 8.9543 8.59848C8.38755 8.31511 7.80826 8.10442 7.26602 8.04015C6.73803 7.97758 6.06213 8.03838 5.55734 8.54317C5.28037 8.82013 5.13658 9.15272 5.07389 9.47901C4.93538 9.67316 4.79896 9.89937 4.6704 10.1285C4.46062 10.5023 4.23042 10.9597 3.99457 11.4683C3.52265 12.4859 3.01189 13.7436 2.58037 15.0145C2.1513 16.2781 1.78737 17.5931 1.62795 18.7149C1.54854 19.2737 1.51364 19.8257 1.56404 20.319C1.61214 20.7897 1.75227 21.3537 2.15888 21.7785C2.57517 22.2134 3.14557 22.3663 3.61676 22.4211C4.11044 22.4786 4.66429 22.4475 5.2236 22.3711C6.34704 22.2177 7.66964 21.8555 8.94144 21.4268C10.2209 20.9955 11.4892 20.4831 12.5153 20.0096C13.0281 19.773 13.4892 19.542 13.8657 19.3316C14.0966 19.2026 14.3249 19.0655 14.5205 18.9262C14.847 18.8636 15.1797 18.7198 15.4568 18.4427C15.9616 17.9379 16.0224 17.262 15.9598 16.734C15.8956 16.1917 15.6849 15.6124 15.4015 15.0457C14.8298 13.9023 13.8548 12.598 12.6284 11.3716ZM8.05987 10.3873C8.9639 10.8394 10.0975 11.6691 11.2142 12.7858C12.3309 13.9025 13.1606 15.0361 13.6127 15.9401C13.8375 16.3898 13.9436 16.7328 13.9724 16.9586C13.6733 16.9208 13.1445 16.7396 12.4176 16.3016C11.6163 15.8187 10.7002 15.1003 9.79998 14.2C8.89973 13.2998 8.18125 12.3837 7.69837 11.5824C7.26038 10.8555 7.07919 10.3267 7.04145 10.0276C7.26718 10.0564 7.61017 10.1625 8.05987 10.3873Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9999 9.00003C20.4476 9.00003 19.9999 9.44775 19.9999 10C19.9999 10.5523 20.4476 11 20.9999 11H21.0099C21.5622 11 22.0099 10.5523 22.0099 10C22.0099 9.44775 21.5622 9.00003 21.0099 9.00003H20.9999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9999 11C15.4476 11 14.9999 11.4477 14.9999 12C14.9999 12.5523 15.4476 13 15.9999 13H16.0099C16.5622 13 17.0099 12.5523 17.0099 12C17.0099 11.4477 16.5622 11 16.0099 11H15.9999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8574 16.4855C21.4751 14.1816 19.0448 13.6978 16.8585 14.0101C16.3118 14.0882 15.9319 14.5947 16.01 15.1415C16.0881 15.6882 16.5946 16.0681 17.1413 15.99C18.8869 15.7406 20.3321 16.164 21.1424 17.5145C21.4266 17.9881 22.0408 18.1417 22.5144 17.8575C22.988 17.5734 23.1416 16.9591 22.8574 16.4855Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9999 18C17.4476 18 16.9999 18.4477 16.9999 19C16.9999 19.5523 17.4476 20 17.9999 20H18.0099C18.5622 20 19.0099 19.5523 19.0099 19C19.0099 18.4477 18.5622 18 18.0099 18H17.9999Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgPartyPopper);
export default ForwardRef;
